module.exports = __webpack_public_path__ + "assets/normal/images/share9.906cb9ef.png";